var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
export var DEFAULT_BATCH_SIZE = 10;
export var batchEvents = function (events, maxBatchSize) {
    if (events === void 0) { events = []; }
    if (maxBatchSize === void 0) { maxBatchSize = DEFAULT_BATCH_SIZE; }
    var doNotBatch = events.length < maxBatchSize || maxBatchSize === 0;
    if (doNotBatch)
        return [__spreadArray([], events)];
    return events.reduce(function (batches, event, i) {
        var chunkIndex = Math.floor(i / maxBatchSize);
        batches[chunkIndex] = __spreadArray(__spreadArray([], (batches[chunkIndex] || [])), [event]);
        return batches;
    }, []);
};
